import { DatePickerKey } from '.';
export var createDatePickerDriver = function (wrapper, key) {
    if (key === void 0) { key = DatePickerKey; }
    var base = wrapper.$("." + key);
    return {
        selectedDay: function (idx) {
            if (idx === void 0) { idx = 0; }
            return base.$$('.rdr-Day.is-selected').get(idx).text();
        },
        selectedMonth: function () { return base.$('.rdr-MonthAndYear-month').text(); },
        selectedYear: function () { return base.$('.rdr-MonthAndYear-year').text(); },
        clickDay: function (day) { return base.$$('.rdr-Day:not(.is-passive)').get(day - 1).click(); },
        clickNextMonth: function () { return base.$('.rdr-MonthAndYear-button.next').click(); },
        clickPreviousMonth: function () { return base.$('.rdr-MonthAndYear-button.prev').click(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map